import {writable, readable} from 'svelte/store';

export const baseUrl = readable('https://crm.chrono-chape.fr/api/');
export const cookieName = readable('chronochape_token');
export const authenticationStatus = writable({authenticated: false});
